import React from 'react';
import PropTypes from 'prop-types';
import TaskModule from 'modules/task';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';

class JobNewTaskForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(),
      error: {},
      isChanged: false,
      showCloseModal: false,
    };
    this.onFormChange = this._onFormChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (this.props.job.state === 'submitted'
        || this.props.job.state === 'in_progress'
        || this.props.job.state === 'completed') {
      Utils.Router.transitionTo('/jobs');
    }
    this.props.dispatch(ReduxActions.constant.fetchList());
    this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.customFieldGroups !== this.props.customFieldGroups
      && !Utils.Helper.isNullOrUndefined(nextProps.account.addons_setting)
      && nextProps.account.addons_setting.custom_field) {
      const customFieldGroupId = this.state.form.custom_field_group_id;

      this._onFormChange('custom_fields_attributes',
        this._getCustomFieldsDefaultForm(this.state.form.custom_fields_attributes,
          nextProps.customFieldGroups[customFieldGroupId]));
    }
  }

  _getDefaultForm() {
    const baseTask = this.props.job.base_task || {};
    return {
      job_id: Utils.Router.getParams().id,
      job_type: this.props.job.job_type,
      address_attributes: {
        name: null,
        line_1: null,
        country: null,
        zip: null,
        contact_person: null,
        contact_number: null,
        email: null,
      },
      time_type: baseTask.time_type || null,
      time_from: baseTask.time_from || null,
      time_to: baseTask.time_to || null,
      time_window_id: Utils.Helper.isNullOrUndefined(baseTask.time_window)
        ? baseTask.time_window_id : baseTask.time_window.id,
      epod_attachments_attributes: [],
      custom_field_group_id: null,
      custom_fields_attributes: (this.props.account.addons_setting || {}).custom_field
        ? [] : undefined,
    };
  }

  _getCustomFieldsDefaultForm = (customFields, customFieldGroup) => {
    if (Utils.Helper.isNullOrUndefined(customFieldGroup)) {
      return [];
    }

    return customFieldGroup.custom_field_descriptions.map((item) => {
      const customField = Utils.Helper.isNullOrUndefined(customFields) ? {}
        : customFields.find((field) => {
          const id = Utils.Helper.isNullOrUndefined(field.custom_field_description)
            ? field.custom_field_description_id : field.custom_field_description.id;

          return id === item.id;
        });
      const value = (customField || {}).value;
      const subvalue = (customField || {}).subvalue;
      return {
        custom_field_description_id: item.id,
        value,
        subvalue,
        id: (customField || {}).id,
      };
    });
  }

  _onFormChange(fieldName, value, index, isDelete, shouldChange = true) {
    if (fieldName === 'custom_field_group_id') {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, null, {
          custom_field_group_id: value,
          custom_fields_attributes: [],
        }),
        isChanged: shouldChange ? true : prevState.isChanged,
      }));

      if (!Utils.Helper.isNullOrUndefined(value)) {
        this.props.dispatch(ReduxActions.customFieldGroup.fetch(value));
      }
    } else if (fieldName === 'billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      this.setState(prevState => ({
        form: {
          ...prevState.form,
          billing_account_id: value,
        },
      }));
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
        isChanged: shouldChange ? true : prevState.isChanged,
      }));
    }
  }

  _renderButton() {
    const { form } = this.state;
    if (
      Utils.Helper.isNonEmptyString(form.address_attributes.country)
        && Utils.Helper.isNonEmptyString(form.address_attributes.line_1)
        && Utils.Helper.isNonEmptyString(form.time_from)
    ) {
      return (
        <Components.Form.MobileMainButton
          iconClassName="versa-completed"
          id="vf-mobile-job__new-task-form__save-button"
          onClick={() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              this.props.strings.Task.form.saving,
            );
            this.props.dispatch(ReduxActions.task.create({
              ...this.state.form,
              job_type: undefined,
            }))
              .then(() => {
                this.props.dispatch(ReduxActions.job.fetch(Utils.Router.getParams().id));
              })
              .catch((error) => {
                this.setState({ error });
              })
              .then(() => {
                Utils.FullScreenLoading.FullScreenLoadingManager.close();
              });
          }}
        >
          {this.props.strings.Task.form.buttons.save}
        </Components.Form.MobileMainButton>
      );
    }

    return false;
  }

  render() {
    return (
      <Components.Form.MobileCoreLayout
        footer={this._renderButton()}
        header={(
          <Components.Mobile.NavigationBar
            leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
            onLeftButtonClick={() => {
              if (this.state.isChanged) {
                this.setState({ showCloseModal: true });
              } else {
                Utils.Router.transitionTo('/jobs');
              }
            }}
            title={(
              <Components.Form.MobileTitle>
                <Components.Form.MobileTitle.Item>
                  {this.props.job.guid}
                </Components.Form.MobileTitle.Item>
                <Components.Form.MobileTitle.Item isHighlighted>
                  {this.props.strings.Task.form.menu.newTask}
                </Components.Form.MobileTitle.Item>
              </Components.Form.MobileTitle>
            )}
          />
        )}
      >
        <TaskModule.Edit
          constant={this.props.constant}
          customFieldGroups={this.props.customFieldGroups}
          customer={this.props.customer}
          data={this.state.form}
          error={this.state.error}
          form={this.state.form}
          id="vf-mobile-job__new-task-form"
          isNewTask
          onFormChange={this.onFormChange}
          optionCustomFieldGroups={this.props.optionCustomFieldGroups}
        />
        <Components.Form.CloseConfirmationDialog
          leftButtonOnClick={() => Utils.Router.transitionTo('/jobs')}
          rightButtonOnClick={() => this.setState({ showCloseModal: false })}
          visible={this.state.showCloseModal}
        />
      </Components.Form.MobileCoreLayout>
    );
  }
}

JobNewTaskForm.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
    }),
  }).isRequired,
  constant: PropTypes.shape().isRequired,
  customFieldGroups: PropTypes.shape({}),
  customer: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  job: PropTypes.shape({
    guid: PropTypes.string,
    job_type: PropTypes.string,
    base_task: PropTypes.shape(),
    state: PropTypes.string,
  }),
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape({})),
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      form: PropTypes.shape({
        saving: PropTypes.string,
        buttons: PropTypes.shape({
          save: PropTypes.string,
        }),
        menu: PropTypes.shape({
          newTask: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobNewTaskForm.defaultProps = {
  customFieldGroups: {},
  optionCustomFieldGroups: [],
  job: {
    guid: '',
    job_type: '',
  },
};

const mapStateToProps = (state) => {
  const {
    account, customFieldGroup, profile, constant, job,
  } = state;

  return {
    account: account.account,
    constant: constant.constant,
    customer: profile.profile,
    customFieldGroups: customFieldGroup.customFieldGroups,
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups,
    job: job.jobs[Utils.Router.getParams().id],
  };
};

export default connect(mapStateToProps)(translate('')(JobNewTaskForm));
